// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_TravelerInfo_box-2GWkYRv","dotsButton":"qempo_TravelerInfo_dotsButton-3sKgTXV","topContent":"qempo_TravelerInfo_topContent-3_4LaKP","infoWrap":"qempo_TravelerInfo_infoWrap-4zy0FAZ","name":"qempo_TravelerInfo_name-16n41MM","flight":"qempo_TravelerInfo_flight-3xrz5Va","bottomContent":"qempo_TravelerInfo_bottomContent-15kKiM_"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/TravelerInfo/TravelerInfo.scss
// module id = 1854
// module chunks = 0